<template>
  <div class="add-rule">
    <div class="rugelatory-container">
      <div class="title">{{ title }}</div>
      <div class="sub-title">
        <el-input
          v-model="subTitle"
          clearable
          class="gray white"
        ></el-input>
      </div>
      <div class="editor-container" ref="editor">
        <editor :catchData="catchData" :content="content"></editor>
      </div>
      <div class="foot">
        <el-button class="btn-white" @click="cancle">取消</el-button>
        <el-button class="btn-blue" @click="save">发布</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from "@/components/Editor";
import { config } from "@/common/js/config.js";
import Authoritative from "@/models/authoritative.js";
export default {
  components: {
    Editor
  },

  data() {
    return {
      subTitle: '',
      title: '规制文本模块',
      content: '',
      categoryId: ''
    }
  },

  created() {
    config();
    this.categoryId = this.$route.query.categoryId
  },

  methods: {
    // 富文本编辑器内容
    catchData(value) {
      this.content = value; // 在这里接受子组件传过来的参数，赋值给data里的参数
    },
    cancle() {
      this.$router.go(-1)
    },
    save() {
      this.$confirm("是否发布此时编辑的规制？", "确认发布", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-gray'
      }).then(() => {
        let categoryId = this.categoryId
        let title = this.subTitle
        let content = this.content
        let data = {
          categoryId,
          title,
          content
        }
        Authoritative.postAddRule(data).then(res => {
          if (res.success) {
            this.$message({
              type: "success",
              message: "发布成功",
            });
            this.cancle()
          } else {
            this.$message.error(res.message)
          }
        })
      });
    }
  }
}
</script>

<style lang='scss'>
.add-rule {
  flex: 1;
  background: $bg-white;
  .title {
    box-sizing: border-box;
    width: 100%;
    height: 44px;
    @include flex-start;
  }
  .sub-title {
    margin-top: 16px;
    font-size: $fs-small-l;
    font-weight: 400;
    color: rgb(137,137,137);
  }
  .editor {
    width: 32px;
    height: 80px;
    margin: 0px 16px;
    padding: 0px 6px;
    background: $bg-white;
    box-shadow: 0px 3px 7px 0px rgba(35, 52, 70, 0.12);
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-evenly;
  }
  .rugelatory-container {
    height: 100%;
    padding: 15px;
    position: relative;
  }
  .editor-container {
    width: 100%;
    padding: 24px 0px 0 0px;
    margin-bottom: 70px;
  }
  .foot {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 64px;
    @include flex-center;
    border-top: 1px solid $bg-ShallowLightSnow;
  }
}
</style>
